import { css } from '@emotion/react';
import { Icon } from '@frontend/icons';
import { theme } from '@frontend/theme';
import { Button, Text } from '@frontend/design-system';
import { draggableStyles } from './styles';

const ARROW_SIZE = 8;

type WarningTooltipProps = {
  message: string;
  onDismiss?: () => void;
};

export const WarningTooltip = ({ message, onDismiss }: WarningTooltipProps) => {
  return (
    <div
      css={[
        css`
          position: absolute;
          left: 100%;
          top: 50%;
          transform: translateY(-50%);
          margin-left: ${ARROW_SIZE + 4}px;
          background: ${theme.colors.warning5};
          border: 1px solid ${theme.colors.warning50};
          border-radius: ${theme.borderRadius.medium};
          max-width: 224px;
          width: max-content;
          padding: ${theme.spacing(1, 1.5)};

          // Arrow pointing left
          &::before {
            content: '';
            position: absolute;
            top: 50%;
            right: 100%;
            transform: translateY(-50%);
            border: ${ARROW_SIZE}px solid transparent;
            border-right-color: ${theme.colors.warning50};
          }
          &::after {
            content: '';
            position: absolute;
            top: 50%;
            right: 100%;
            transform: translateY(-50%);
            border: ${ARROW_SIZE - 1}px solid transparent;
            border-right-color: ${theme.colors.warning5};
            margin-right: -1px;
          }
        `,
        draggableStyles,
      ]}
    >
      <div
        css={css`
          display: flex;
          align-items: flex-start;
          gap: ${theme.spacing(1)};
        `}
      >
        <Icon
          name='alert-filled'
          size={16}
          css={css`
            flex-shrink: 0;
            margin-top: 2px;
          `}
        />
        <Text
          size='small'
          css={css`
            color: ${theme.font.colors.default};
          `}
        >
          {message}
        </Text>
        <Button
          aria-label='Dismiss warning'
          variant='secondary'
          size='tiny'
          iconName='x'
          onClick={(e) => {
            e.stopPropagation();
            onDismiss?.();
          }}
        />
      </div>
    </div>
  );
};
